import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiMenus } from "~/routes"

import PageContainer from "~/library/PageContainer"
import MenuForm from "~/components/MenuForm"

const NewMenu = () => {
  const { venueSlug } = getAppConfig()
  const [createdMenuId, setCreatedMenuId] = useState<string | null>(null)
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      menu: formValues,
    }

    const req = apiMenus.create({ data })

    req
      .then(({ menu }) => {
        setCreatedMenuId(menu.id)
        toast("Menu created successfully", "success")
      })
      .catch((res) => {
        toast(`${res.body?.errors?.join(", ") || "Please try again"}`, "danger")
      })
  }

  if (createdMenuId) {
    return <Navigate to={`/menus/${createdMenuId}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">New Menu</h3>
          <MenuForm venueSlug={venueSlug} onSubmit={handleSubmit} />
        </div>
      </div>
    </PageContainer>
  )
}

export default NewMenu
